import { FaStar, FaStarHalfAlt } from 'react-icons/fa'

export function TrustpilotBadge({ className = '', rating = '4halfstar' }) {
  const renderStars = () => {
    switch (rating) {
      case '4star':
        return (
          <>
            {[...Array(4)].map((_, i) => (
              <FaStar
                key={i}
                className="h-5 w-5 fill-orange-400 text-orange-400"
              />
            ))}
            <FaStarHalfAlt className="h-5 w-5 fill-orange-400 text-orange-400" />
          </>
        )
      case '4halfstar':
        return (
          <>
            {[...Array(4)].map((_, i) => (
              <FaStar
                key={i}
                className="h-5 w-5 fill-orange-400 text-orange-400"
              />
            ))}
            <FaStarHalfAlt className="h-5 w-5 fill-orange-400 text-orange-400" />
          </>
        )
      case '5star':
        return (
          <>
            {[...Array(5)].map((_, i) => (
              <FaStar
                key={i}
                className="h-5 w-5 fill-orange-400 text-orange-400"
              />
            ))}
          </>
        )
      default:
        return (
          <>
            {[...Array(4)].map((_, i) => (
              <FaStar
                key={i}
                className="h-5 w-5 fill-orange-400 text-orange-400"
              />
            ))}
            <FaStar className="h-5 w-5 fill-gray-300 text-gray-300" />
          </>
        )
    }
  }

  return (
    <div
      className={`inline-flex items-center gap-1.5 rounded-lg border border-gray-100 bg-white px-3 py-2 shadow-sm sm:gap-2 sm:px-4 ${className}`}
    >
      <span className="text-xs font-bold whitespace-nowrap text-gray-900 sm:text-sm">
        Excellent
      </span>
      <div className="flex gap-0.5">{renderStars()}</div>
      <span className="text-xs whitespace-nowrap text-gray-600 sm:text-sm">
        Rated 4.5 on Google
      </span>
    </div>
  )
}

export default TrustpilotBadge
